import { Box, Divider, Grid, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import Summary from 'components/summary/summary'
import { useMappedTranslation } from 'hooks'
import useLinkedServicesQuery from 'queries/use-linked-services-query'
import useSamsungServicesQuery from 'queries/use-samsung-services-query'
import { isRtl } from 'utils/i18n'

import { AutomationTagIds } from '../../../../assets/test/test-automation-tag-id'
import IconMore from '../assets/images/more.svg'
import IconService from '../assets/images/service.svg'

const ServiceSummary = () => {
  const t = useMappedTranslation()
  const theme = useTheme()

  const MAX_ITEM = 5

  const { data: samsungServices = [], isLoading: isLoadingSamsungServices } = useSamsungServicesQuery()
  const { data: linkedServices = [], isLoading: isLoadingLinkedServices } = useLinkedServicesQuery()

  const samsungServiceCount = samsungServices.length
  const linkedServiceCount = linkedServices.length

  return (
    <Summary
      pageUrl={'/dashboard/services'}
      isLoading={isLoadingLinkedServices || isLoadingSamsungServices}
      paperSx={{ paddingBottom: '24px !important' }}
      titleIcon={IconService}
      title={t('service.title')}
      content={
        <>
          <Box
            sx={{ width: '100%', marginTop: { xs: '14px', md: '18px' }, lineHeight: { xs: '22px', md: '14px' } }}
            data-testid={AutomationTagIds['cards.dashboard-services-list']}
          >
            <Typography variant='label2' sx={{ color: theme.palette.secondary.light }}>{`${t(
              'service.samsung.samsung_apps_and_services',
              {
                0: samsungServiceCount
              }
            )}`}</Typography>
          </Box>
          <Grid container justifyContent='flex-start' sx={{ marginTop: { xs: '12px', md: '16px' } }}>
            {samsungServiceCount === 0 ? (
              <Box sx={{ width: '100%', height: '100%', textAlign: 'center', lineHeight: '22px', pb: '14px' }}>
                <Typography>{t('service.samsungService.connected.noService')}</Typography>
              </Box>
            ) : (
              <>
                {samsungServices.slice(0, MAX_ITEM - 1).map((service, index) => (
                  <Grid key={service.applicationId} item sx={{ justifyContent: 'center', height: '48px' }}>
                    <Box
                      component='img'
                      alt=''
                      src={service.iconUrl}
                      sx={{
                        width: '48px',
                        height: '48px',
                        marginLeft: !isRtl && index > 0 ? '20px' : '0',
                        marginRight: isRtl && index > 0 ? '20px' : '0'
                      }}
                    />
                  </Grid>
                ))}
                {samsungServiceCount > MAX_ITEM - 1 && (
                  <Grid item sx={{ justifyContent: 'center', height: '48px', alignItems: 'center', display: 'flex' }}>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '25px',
                        height: '25px',
                        marginLeft: !isRtl ? { xs: '20px', md: '24px' } : 0,
                        marginRight: isRtl ? { xs: '20px', md: '24px' } : 0
                      }}
                    >
                      <Box component='img' src={IconMore} sx={{ width: '48px', height: '48px' }} alt='' />
                    </Box>
                  </Grid>
                )}
              </>
            )}
          </Grid>
          <Divider sx={{ width: '100%', margin: { xs: '14px 0', md: '20px 0 18px' } }} />
          <Box sx={{ width: '100%', lineHeight: { xs: '22px', md: '14px' } }}>
            <Typography
              variant='label2'
              sx={{ color: theme.palette.secondary.light }}
              data-testid={AutomationTagIds['cards.dashboard-connected-services-list']}
            >{`${t('service.linkedServices.title')} (${linkedServiceCount})`}</Typography>
          </Box>

          <Grid container justifyContent='flex-start' sx={{ marginTop: { xs: '8px', md: '16px' } }}>
            {linkedServiceCount === 0 ? (
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  textAlign: 'center',
                  lineHeight: '22px',
                  pb: '14px'
                }}
              >
                <Typography lineHeight='22px'>{t('service.linkedServices.noService')}</Typography>
              </Box>
            ) : (
              <>
                {linkedServices.slice(0, MAX_ITEM - 1).map((service, index) => (
                  <Grid key={service.applicationId} item sx={{ justifyContent: 'center', height: '48px' }}>
                    <Box
                      component='img'
                      alt=''
                      src={service.iconUrl}
                      sx={{
                        width: '48px',
                        height: '48px',
                        marginLeft: !isRtl && index > 0 ? '20px' : '0',
                        marginRight: isRtl && index > 0 ? '20px' : '0'
                      }}
                    />
                  </Grid>
                ))}
                {linkedServiceCount > MAX_ITEM - 1 && (
                  <Grid item sx={{ justifyContent: 'center', height: '48px', alignItems: 'center', display: 'flex' }}>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '25px',
                        height: '25px',
                        marginLeft: !isRtl ? { xs: '20px', md: '24px' } : 0,
                        marginRight: isRtl ? { xs: '20px', md: '24px' } : 0
                      }}
                    >
                      <Box component='img' src={IconMore} sx={{ width: '48px', height: '48px' }} alt='' />
                    </Box>
                  </Grid>
                )}
              </>
            )}
          </Grid>
        </>
      }
    />
  )
}

export default ServiceSummary
